import { doRequest, getWorksheetFromRange } from "./util";

/* global window, console, Excel, URL */

export async function loadLimprReport(portfolio_id: number, report_id: number, address: string) {
    try {
        const myUrl = new URL(window.api_url + '/feeder/limpr_report');
        if (portfolio_id !== undefined && portfolio_id !== null) {
            myUrl.searchParams.append("portfolio_id", encodeURIComponent(portfolio_id));
        }
        if (report_id !== undefined && report_id !== null) {
            myUrl.searchParams.append("report_id", encodeURIComponent(report_id));
        }
        const url = myUrl.href;
        let response = await doRequest(url);
        if (!response.ok) {
            let error = await response.json();
            return [['failed request: ' + response.status + ' ' + response.statusText + ' ' + error.message + ' ' + url]];
        }
        let json = await response.json();
        const report = json.report;
        const limpr: string[][] = [];
        if (report !== undefined && report !== null) {
            const keys = Object.keys(report);
            keys.forEach(key => {
                limpr.push([key, '', '', '', '', '', '', '', '', '']);
                limpr.push(['Metering Point', 'LP ID', 'LP Data From', 'LP Data To', 'Frame', 'Gaps', 'Last Forecast', 'ID', 'Forecast From', 'Forecast To']);
                report[key].forEach((element: any) => {
                    limpr.push([element["Metering Point"], element["LP ID"], element["LP Data From"], element["LP Data To"], element["Frame"], '', element["Last Forecast"], element["ID"], element["Forecast From"], element["Forecast To"]]);
                    const gaps = element["Gap Periods"];
                    if (gaps !== undefined && gaps !== null && gaps.length > 0) {
                        limpr[limpr.length - 1][5] = gaps[0][0] + ' - ' + gaps[0][1];
                        gaps.splice(0, 1);
                        gaps.forEach((gap: string[]) => {
                            limpr.push(['', '', '', '', '', gap[0] + ' - ' + gap[1], '', '', '', ''])
                        });
                    }
                });
            })
        }
        if (limpr.length > 0) {
            const context = new Excel.RequestContext();
            const range = context.workbook.worksheets.getItem(getWorksheetFromRange(address)).getRange(address.split('!')[1]).getResizedRange(limpr.length - 1, 9);
            range.values = limpr;
            range.copyFrom(range, Excel.RangeCopyType.values);
            await context.sync();
            return;
        } else {
            return [['no limpr data could be found']];
        }
    } catch(error: any) {
        console.error(error);
        return [['error occured in addin: ' + error.message]];
    }
}